import React from "react";
import { getCellColor, sxStyles } from "../sharedStyles";
import { Box, Skeleton, SxProps, Typography } from "@mui/material";
import { IPriceItinerary } from "../interfaces.lowPrice";

interface IProps {
  selectedItineraryId: string | null;
  priceItinerary: IPriceItinerary;
  maxMin: { max: number; min: number };
}

export const DesktopSkeleton = (props: IProps) => {
  const { selectedItineraryId, priceItinerary: itinerary, maxMin } = props;

  const cellColorStyles: SxProps = {
    ...getCellColor(
      selectedItineraryId === itinerary.id,
      itinerary.price,
      maxMin,
    ),
  };

  const { desktopButtonPrice, desktopButtonRow } = sxStyles;

  return (
    <>
      <Box sx={desktopButtonPrice}>
        <Typography variant="h5" sx={{ ...cellColorStyles }}>
          <Skeleton width={76} height={32} sx={{ marginBottom: "auto" }} />
        </Typography>
      </Box>
      <Box sx={desktopButtonRow}>
        <Skeleton width={50} height={20} />
        <Skeleton width={30} height={20} sx={{ marginLeft: "auto" }} />
      </Box>
      <Box sx={desktopButtonRow}>
        <Skeleton width={50} height={20} />
        <Skeleton width={30} height={20} sx={{ marginLeft: "auto" }} />
      </Box>
    </>
  );
};

export const MobileSkeleton = (props: IProps) => {
  const { selectedItineraryId, priceItinerary: itinerary, maxMin } = props;

  const cellColorStyles: SxProps = {
    ...getCellColor(
      selectedItineraryId === itinerary.id,
      itinerary.price,
      maxMin,
    ),
  };

  const {} = sxStyles;

  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Typography variant="bodySmall">
          <Skeleton width={20} />
        </Typography>
        <Typography
          variant="titleMedium"
          weight="bold"
          sx={{ ...cellColorStyles }}
        >
          <Skeleton width={28} />
        </Typography>
      </Box>
    </>
  );
};
